<list-view *ngIf="listeFiltreCollaborateur" [liste]="listeFiltreCollaborateur"></list-view>
<list-view *ngIf="listeFiltreResponsable && isResponsable" [liste]="listeFiltreResponsable"></list-view>
<list-view *ngIf="listePopulation" [liste]="listePopulation"></list-view>
